import api from '.'

export const tasks = {
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/tasks`, data, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/tasks`, null, success, fail)
  },
  update (taskId, data, success, fail) {
    api.authenticatedRequest('PUT', `/tasks/${taskId}`, data, success, fail)
  },
  delete (taskId, success, fail) {
    api.authenticatedRequest('DELETE', `/tasks/${taskId}`, null, success, fail)
  }
}
